import { MARKETING_SETTINGS_ACTION_TYPE } from "./marketing-settings.action";

const CONTEXT_PREFIX = "[Marketing Settings]";
export const MARKETING_SETTINGS_MESSAGE_CONTEXT = {
	consents: `${CONTEXT_PREFIX} Consents`,
};

export const MARKETING_SETTINGS_MESSAGE_CODE = {
	updateMarketingSettingsSuccess: "M_UPDATE_MARKETING_SETTINGS_SUCCESS",
	updateMarketingSettingsFail: "E_UPDATE_MARKETING_SETTINGS_FAIL",
	updateCustomerConsentsSuccess: "M_UPDATE_CONSENT_SUCCESS",
	updateCustomerConsentsFail: "E_UPDATE_CONSENT_FAIL",
	updateMarketingSettingsFromLoginFlowSuccess: "M_UPDATE_CONSENT_SUCCESS",
	updateMarketingSettingsFromLoginFlowFail: "E_UPDATE_CONSENT_FAIL",
	updateMarketingSettingsWithTokenFail: "E_UPDATE_MARKETING_WITH_TOKEN_FAIL",
	getConsents: MARKETING_SETTINGS_ACTION_TYPE.getConsents,
};

export const MARKETING_SETTINGS_ERROR_CODE = {
	getCustomerConsentsNotFound: "E_CUSTOMERCONSENT_NOTFOUND",
};

export const MARKETING_CONSENT_FORM_NAME = "CRM_Preference";
